/*
 * Adapptio Editor
 *
 * @package editor
 * @copyright 2021-2025 Hexio a.s. <contact@hexio.io> (hexio.io) and contributors.
 * @license Apache-2.0
 *
 * See LICENSE file distributed with this source code for more information.
 */

import React from "react";
import { BEM } from "@adapptio/lib-components";
import { Panel, PANEL_STYLE, PanelNote } from "../../../../../../ui/components/Panel";

export interface IThemeEditorMainDefaultProps {
	className?: string;
}

export const ThemeEditorMainDefault: React.FC<IThemeEditorMainDefaultProps> = ({ className }) => {
	const baseClass = BEM("edt-theme-editor-main-default");

	if (className) {
		baseClass.add(className);
	}

	return (
		<Panel style={PANEL_STYLE.NONE} className={baseClass.toClassName()}>
			<PanelNote align="center">
				Select item from outline to edit it.
			</PanelNote>
		</Panel>
	);
};
